import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { L as Link } from '../Text/Link/Link-B57uSqU0.js';
import { T as TextButton } from '../Button/TextButton/TextButton-DVKktbSB.js';
import { b as angleInlineEnd } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';
import { I as Icon } from '../Icon/Icon-CtwBWqCc.js';
import { T as Text } from '../Text/Text-zB1lKx2Q.js';

const NodeSafeHTMLElement = typeof HTMLElement !== 'undefined' ? HTMLElement : Object;
const BreadcrumbArrow = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30063520__sc-beoevh-0"
})(["padding:0 ", ";color:", ";", ""], ({
  theme
}) => theme.spacing.small, ({
  theme
}) => theme.breadcrumbs.spacer, isMobile(css(["padding:0 ", ";"], ({
  theme
}) => theme.mobile.spacing.small)));
BreadcrumbArrow.displayName = 'BreadcrumbArrow';
const StyledText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-30063520__sc-beoevh-1"
})(["color:", ";"], ({
  theme
}) => theme.palette.emperor);
StyledText.displayName = 'StyledText';
class Breadcrumb extends PureComponent {
  render() {
    const {
      href,
      label,
      onClick,
      isFinal,
      children,
      elementRef,
      ...rest
    } = this.props;
    let component;
    if (children) {
      component = children;
    } else if (href) {
      component = /*#__PURE__*/React__default.createElement(Link, _extends({}, rest, {
        href: href,
        anchorRef: elementRef
      }), label);
    } else if (onClick) {
      component = /*#__PURE__*/React__default.createElement(TextButton, _extends({}, rest, {
        onClick: onClick,
        buttonRef: elementRef
      }), label);
    } else {
      component = /*#__PURE__*/React__default.createElement(StyledText, _extends({}, rest, {
        elementRef: elementRef
      }), label);
    }
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, component, !isFinal && /*#__PURE__*/React__default.createElement(BreadcrumbArrow, {
      type: angleInlineEnd
    }));
  }
}
_defineProperty(Breadcrumb, "propTypes", {
  /**
   * Use to add a link to breadcrumb
   */
  href: PT.string,
  /**
   * Text of breadcrumb item
   */
  label: PT.string,
  /**
   * Use to render a button with callback when no href exists
   */
  onClick: PT.func,
  /**
   * Controlled by BreadcrumbGroup. No need to enter manually.
   */
  isFinal: PT.bool,
  /**
   * Use if you need a custom component such as a react router link
   */
  children: PT.node,
  /**
  * A React Ref that contains the underlying HTMLElement this breadcrumb will be render.
  * This may be a HTMLAnchorElement, HTMLButtonElement, or HTMLParagraphElement
  */
  elementRef: PT.shape({
    current: PT.instanceOf(NodeSafeHTMLElement)
  })
});
_defineProperty(Breadcrumb, "defaultProps", {
  href: undefined,
  label: undefined,
  onClick: undefined,
  isFinal: false,
  children: undefined,
  elementRef: undefined
});

export { Breadcrumb as B };
//# sourceMappingURL=Breadcrumb-oVd2jUlp.js.map
